import React from 'react';
import { Link } from 'react-router-dom';
import logoXB from '../images/logoXB.png';
import './Header.css';

function Header() {
  return (
    <header className="header">
      <div className="header__inner">
        <Link to="/todos" className="header__logo">
          <img src={logoXB} alt="Xadrez Brasil" />
        </Link>
        <nav className="header__nav">
          <Link to="/todos" className="header__link">Todos os Cursos</Link>
        </nav>
      </div>
    </header>
  );
}

export default Header;
